<div class="row mx-0 all_store" id="LocationDivContainer"
    *ngIf="!isUnits && !isUnitType && !SplitModuleUnit && (ModuleName != 'AccountingInterface')" style="width: 100%;">

    <div class="col-md-5 p-0 all_store_lft store_responsive" *ngIf="!IsAcutionDateList">
        <ejs-grid #gridAlldata [dataSource]='AllDataDisplay' height='420' class="table-striped table-ipad table-custom"
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column *ngIf="SelectionName !== 'SSOUsers'" textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30' >
                </e-column>
                <e-column field='Name' width='110' textAlign='Left'>
                    <ng-template #headerTemplate >

                        <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="((AllData.length > 0)||(isFilterAll)) && (SelectionName !== 'SSOUsers')"
                            (click)="openAllFilterModal()"></span>
                          <span #EditLocIcon class="e-icons e-edit" *ngIf="(SelectionName == 'MFALocations')" 
                            (click)="openEditLocModal(1)"></span>
                        {{AllDataHeader}} ({{ AllDataDisplay?.length || 0}})
                    </ng-template>
                    <ng-template #template let-data>
                        <span class="dataName" [title]="data.Name">{{ data.Name ? data.Name : (data.FirstName + ' ' + data.LastName) }}</span>
                    </ng-template>
                </e-column>
                <e-column field='Percentage' width='70' textAlign='Left' *ngIf="ModuleName == 'Taxes'">
                    <ng-template #template let-data>
                        <span class="dataName">{{ makeTwoDecimals(data.Percentage) }}</span>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

    </div>
    <div class="col-md-2 store_middle_responsive" *ngIf="!IsAcutionDateList">
        <div class="arrowsContainer"  *ngIf="SelectionName !== 'SSOUsers'">
            <div class="button_tooltip" >
                <img class="arrowRight" src="../../../assets/images/Arrow Right.png" (click)="(!facilityEditRight && disableStoreSelection && auctionId != 0) ? null : validateAddToActiveGrid()">
                <div class="button_tooltip_modal" *ngIf="this.ModuleName == 'WebHookSubscription' && this.PermissionsWebhooksubscription && !this.PermissionsWebhooksubscription.CreateRight">
                    <p class="mb-0">You do not have rights to Create New</p>
                    <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
                </div>
            </div>
            <br>
            <div class="button_tooltip">
                <img class="arrowLeft" src="../../../assets/images/Arrow Left.png" (click)="(!facilityEditRight && disableStoreSelection && auctionId != 0) ? null : validateAddToAllGrid()">
                <div class="button_tooltip_modal" *ngIf="this.ModuleName == 'WebHookSubscription' && this.PermissionsWebhooksubscription && !this.PermissionsWebhooksubscription.DeleteRight">
                    <p class="mb-0">You do not have rights to Delete</p>
                    <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-5 p-0 all_store_rgt store_responsive" [style.width.px]="IsAcutionDateList ? 396 : null" id="excludedUserGrid">

        <ejs-grid #gridActiveData [dataSource]='ActiveDataDisplay' height='420' class="table-striped table-ipad"
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage' (dataBound)="onGridDataBound() "(rowSelecting)="onRowSelecting($event)">
            <e-columns>
                <e-column *ngIf="SelectionName !== 'SSOUsers' && !IsAcutionDateList" textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='Name' width='110' textAlign='Left' [customAttributes]="{ class: (SelectionName === 'AvailableNotifications' && 'e-notification')}">
                <ng-template #headerTemplate>
                    <span #ActiveFilterIcon class="e-icons e-icon-filter icon" [ngClass]="{'e-tax-included': ModuleName == 'Taxes'}"
                        *ngIf="((ActiveData.length > 0)||(isFilterActive)) && SelectionName !== 'SSOUsers' && SelectionName !== 'AvailableNotifications'"
                        (click)="openActiveFilterModal()" [title]="ActiveHeader">
                    </span>
                    <span>
                        {{ActiveHeader}} ({{(ActiveDataDisplay?.length || 0)}})
                        <ng-container *ngIf="SelectionName == 'MFALocations'">
                            <i #EditLocIcon class="e-icons e-edit icon-custom" (click)="openEditLocModal(2)"></i>
                        </ng-container>
                        <ng-container *ngIf="SelectionName == 'AvailableNotifications'">
                            <i #EditLocIcon class="e-icons e-icon-filter icon-notification"  *ngIf="((ActiveData.length > 0)||(isFilterActive))" (click)="openEditLocModal(2)"></i>
                        </ng-container>
                    </span>
                </ng-template>
                    <ng-template #template let-data>
                        <span class="dataName" [title]="data.Name">{{ data.Name ? data.Name : (data.FirstName + ' ' + data.LastName) }}</span>
                    </ng-template>
                </e-column>
                <e-column field='Percentage' width='70' textAlign='Left' *ngIf="ModuleName == 'Taxes'">
                    <ng-template #template let-data>
                        <span class="dataName">{{(data.Percentage).toFixed(2)}}</span>
                    </ng-template>
                </e-column>  
                <e-column field='NotificationAlert' headerText='Alert' width='40' textAlign='Center' style="padding-bottom: 0px;" *ngIf="SelectionName =='AvailableNotifications'">
                    <ng-template #template let-data>
                        <input type="checkbox" [checked]="data.NotificationAlert" (click)="$event.stopPropagation()" class="d-inline-block" style="width: 18px; height: 18px; border-radius: 0;"(change)="notificationAleret($event,data)" />
                    </ng-template>
                </e-column>   
            </e-columns>
        </ejs-grid>
    </div>
</div>

<div class="row active_store mx-0" id="LocationDivContainer" *ngIf="ModuleName == 'AccountingInterface'">

    <div class="col-md-6 p-0 active_store_lft" style="min-height: 420px;">
        <ejs-grid #gridAlldata [dataSource]='AllDataDisplay' height='420' class="table-striped  Section_Switch_Table"
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='Name' width='100' headerText='' textAlign='Left'>
                    <ng-template #headerTemplate>
                        {{AllDataHeader}}({{(AllDataDisplay?.length || 0)}})
                        <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="(AllData.length > 0)||(isFilterAll)"
                            (click)="openAllFilterModal()"></span>
                    </ng-template>
                </e-column>
                <e-column field='LastExportDate' headerText=''  width='50' textAlign='Left'>
                    <ng-template #headerTemplate>
                        {{exportDateHeader}}
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

    </div>
    <div class="col-md-2" >
        <div class="arrowsContainer">
            <img class="arrowRight" src="../../../assets/images/Arrow Right.png" (click)="addToActiveGrid()">
            <br>
            <img class="arrowLeft" src="../../../assets/images/Arrow Left.png" (click)="addToAllGrid()">
        </div>
    </div>
    <div class="col-md-4 p-0 active_store_rgt" style="min-height: 420px;">

        <ejs-grid #gridActiveData [dataSource]='ActiveDataDisplay' height='420' class="table-striped "
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='Name' width='150' textAlign='Left'>
                    <ng-template #headerTemplate>
                        <span #ActiveFilterIcon class="e-icons e-icon-filter"
                            *ngIf="(ActiveData.length > 0)||(isFilterActive)" (click)="openActiveFilterModal()"></span>
                        {{ActiveHeader}}({{(ActiveDataDisplay?.length || 0)}})
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>

</div>

<div class="row active_store mx-0" id="LocationDivContainer" *ngIf="isUnits && !SplitModuleUnit">
    <div class="col-md-5 p-0 active_store_lft" style="min-height: 420px;">
        <ejs-grid #gridAlldata [dataSource]='AllDataDisplay' height='420' class="table-striped " [gridLines]='lines'
            [editSettings]="editSettings" allowPaging="true" [allowSelection]="true" [pageSettings]='initialPage'
            [selectionSettings]="selectionOptions">
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='UnitNo' width='150' textAlign='Left' isPrimaryKey="true" *ngIf="ModuleName !== 'Revenueplan'">
                    <ng-template #headerTemplate>
                        <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="(AllData.length > 0)||(isFilterAll)"
                            (click)="openAllFilterModal()"></span>
                        {{AllDataHeader}}({{AllDataDisplay?.length || 0}})
                    </ng-template>
                </e-column>
                <e-column field='UnitNo' width='150' textAlign='Left' isPrimaryKey="true" *ngIf="ModuleName == 'Revenueplan'">
                    <ng-template #headerTemplate>
                        <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="(AllData.length > 0)||(isFilterAll)"
                            (click)="openAllFilterModal()"></span>
                        {{AllDataHeader}}({{AllDataDisplay?.length || 0}})
                    </ng-template>
                    <ng-template #template let-data>
                        <span class="dataName">{{data.UnitNo}}, {{data.FacilityName}}</span>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

    </div>
    <div class="col-md-2">
        <div class="arrowsContainer">
            <img class="arrowRight" src="../../../assets/images/Arrow Right.png" (click)="addToActiveGrid()">
            <br>
            <img class="arrowLeft" src="../../../assets/images/Arrow Left.png" (click)="addToAllGrid()">
        </div>
    </div>
    <div class="col-md-5 p-0 active_store_rgt" style="min-height: 420px;">

        <ejs-grid #gridActiveData [dataSource]='ActiveDataDisplay' allowPaging="true" [allowSelection]="true" height='420'
            class="table-striped " [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'
            [selectionSettings]="selectionOptions">
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='UnitNo' width='150' textAlign='Left' isPrimaryKey="true" *ngIf="ModuleName !== 'Revenueplan'">
                    <ng-template #headerTemplate>
                        <span #ActiveFilterIcon class="e-icons e-icon-filter"
                            *ngIf="(ActiveData.length > 0)||(isFilterActive)" (click)="openActiveFilterModal()"></span>
                        {{ActiveHeader}}({{ActiveDataDisplay?.length || 0}})
                    </ng-template>
                </e-column>
                <e-column field='UnitNo' width='150' textAlign='Left' isPrimaryKey="true" *ngIf="ModuleName == 'Revenueplan'">
                    <ng-template #headerTemplate>
                        <span #ActiveFilterIcon class="e-icons e-icon-filter"
                            *ngIf="(ActiveData.length > 0)||(isFilterActive)" (click)="openActiveFilterModal()"></span>
                        {{ActiveHeader}}({{ActiveDataDisplay?.length || 0}})
                    </ng-template>
                    <ng-template #template let-data>
                        <span class="dataName">{{data.UnitNo}}, {{data.FacilityName}}</span>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>

<div class="row active_store mx-0" id="LocationDivContainer" *ngIf="SplitModuleUnit">

    <div class="col-md-5 p-0 active_store_lft" style="min-height: 420px;">
        <ejs-grid #gridAlldata [dataSource]='AllData' height='420' class="table-striped  Section_Switch_Table"
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='35'>
                </e-column>
                <e-column field='UnitNumber' width='75' headerText='' textAlign='Left'>
                </e-column>
                <e-column field='UnitSize' headerText=''  width='100' textAlign='Left'>
                    <ng-template #headerTemplate>
                        {{AllDataHeader}}({{(AllData?.length || 0)}})
                    </ng-template>
                </e-column>
                <e-column field='FacilitySectionUnitAttributes' [allowSorting]='false' headerText='' width='90'
                    textAlign='Center' type='string'>
                    <ng-template #template let-data>
                        <img [src]="item.MediumImageURL" alt="catagory" [title]="item.AttributeName"
                            style="height: 24px;margin:0 1px;" *ngFor="let item of data.FacilitySectionUnitAttributes">
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>

    </div>
    <div class="col-md-2" >
        <div class="arrowsContainer">
            <img class="arrowRight" src="../../../assets/images/Arrow Right.png" (click)="addToActiveGrid()">
            <br>
            <img class="arrowLeft" src="../../../assets/images/Arrow Left.png" (click)="addToAllGrid()">
        </div>
    </div>

    <div class="col-md-5 p-0 active_store_rgt" style="min-height: 420px;">

        <ejs-grid #gridActiveData [dataSource]='ActiveData' height='420' class="table-striped " [gridLines]='lines'
            [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='35'>
                </e-column>
                <e-column field='UnitNumber' headerText='' width='75' textAlign='Left'>
                </e-column>
                <e-column field='UnitSize' headerText=''  width='100' textAlign='Left'>
                    <ng-template #headerTemplate>
                        {{ActiveHeader}}({{(ActiveData?.length || 0)}})
                    </ng-template>
                </e-column>
                <e-column field='FacilitySectionUnitAttributes' [allowSorting]='false' headerText='' width='90'
                    textAlign='Center' type='string'>
                    <ng-template #template let-data>
                        <img [src]="item.MediumImageURL" alt="catagory" [title]="item.AttributeName"
                            style="height: 24px;margin:0 1px;" *ngFor="let item of data.FacilitySectionUnitAttributes">
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>

<div class="row active_store mx-0" id="LocationDivContainer" *ngIf="isUnitType">

    <div class="col-md-5 p-0 active_store_lft" style="min-height: 420px;">
        <ejs-grid #gridAlldata [dataSource]='AllDataDisplay' height='420' class="table-striped " [gridLines]='lines'
            [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='UnitType' width='150' textAlign='Left'>
                    <ng-template #headerTemplate>
                        <span #AllFilterIcon class="e-icons e-icon-filter " *ngIf="(AllData.length > 0)||(isFilterAll)"
                            (click)="openAllFilterModal()"></span>
                        {{AllDataHeader}}({{(AllDataDisplay?.length || 0)}})
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div class="col-md-2" >
        <div class="arrowsContainer">
            <img class="arrowRight" src="../../../assets/images/Arrow Right.png" (click)="addToActiveGrid()">
            <br>
            <img class="arrowLeft" src="../../../assets/images/Arrow Left.png" (click)="addToAllGrid()">
        </div>
    </div>
    <div class="col-md-5 p-0 active_store_rgt" style="min-height: 420px;">

        <ejs-grid #gridActiveData [dataSource]='ActiveDataDisplay' height='420' class="table-striped "
            [gridLines]='lines' [editSettings]="editSettings" [pageSettings]='initialPage'>
            <e-columns>
                <e-column textAlign='center' type="checkbox" [allowFiltering]='false' [allowSorting]='false' width='30'>
                </e-column>
                <e-column field='UnitType' width='150' textAlign='Left'>
                    <ng-template #headerTemplate>
                        <span #ActiveFilterIcon class="e-icons e-icon-filter"
                            *ngIf="(ActiveData.length > 0)||(isFilterActive)" (click)="openActiveFilterModal()"></span>
                        {{ActiveHeader}}({{(ActiveDataDisplay?.length || 0)}})
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>

</div>

<ejs-toast #toasttype id='toasttype' [position]="toastPosition"></ejs-toast>

<!-- Custom  Filter Templates -->

<!-- available data table filter for users -->
<ng-template #avialableDataUsersFilter>
    <div class="modal-header">
        <h5 class="modal-title" i18n="@@All_Users">Available Users</h5>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ejs-grid #gridFilterAvailabledata [dataSource]='AllFilterData' height='350' class="table-striped "
            [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
            [pageSettings]='initialPage' allowFiltering='true' allowSorting='true' (actionBegin)="actionBegin($event, gridFilterAvailabledata)"
            (created)="createdAll($event,gridFilterAvailabledata)">
            <e-columns>
                <e-column field='FirstName' headerText='First Name' width='120' textAlign='Left' type='string'>
                </e-column>
                <e-column field='LastName' headerText='Last Name' width='120' textAlign='Left' type='string'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary me-3" type="button" [disabled]='disableFilter'
            (click)="clearFilterAll(gridFilterAvailabledata,'CLEAR')">Clear</button>
        <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef.hide()"
            i18n="@@Cancel">Cancel</button>
        <button class="btn btn-primary" type="button" [disabled]='disableFilter'
            (click)="loadToAllGrid(gridFilterAvailabledata,'OK')">OK</button>
    </div>
</ng-template>
<!-- active data table filter for available users -->

<ng-template #activeDataUsersFilter>
    <div class="modal-header">
        <h5 class="modal-title" i18n="@@Active_Users">Active Users</h5>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ejs-grid #gridFilterActivedata [dataSource]='ActiveFilterData' height='350' class="table-striped "
            [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
            [pageSettings]='initialPage' allowFiltering='true' allowSorting='true' (actionBegin)="actionBeginActive($event, gridFilterActivedata)"
            (created)="createdAll($event,gridFilterActivedata)">
            <e-columns>
                <e-column field='FirstName' headerText='First Name' width='120' textAlign='Left' type='string'>
                </e-column>
                <e-column field='LastName' headerText='Last Name' width='120' textAlign='Left' type='string'></e-column>
            </e-columns>
        </ejs-grid>
    </div>
    <div class="modal-footer">
        <button class="btn btn-primary me-3" type="button" [disabled]='disableFilterActive'
            (click)="clearFilterActive(gridFilterActivedata,'CLEAR')">Clear</button>
        <button class="btn btn-outline-primary me-3" type="button" (click)="modalRef.hide()"
            i18n="@@Cancel">Cancel</button>
        <button class="btn btn-primary" type="button" [disabled]='disableFilterActive'
            (click)="loadToActiveGrid(gridFilterActivedata,'OK')">OK</button>
    </div>
</ng-template>


<!-- all data table filter for users -->

<div bsModal #allDataUsersFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Users">{{allUsersModalName}}</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="allDataUsersFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings'
                    (actionBegin)="actionBegin($event, gridFilterAlldata)" (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterAlldata)">
                    <e-columns>
                        <e-column field='FirstName' headerText='First Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                        <e-column field='LastName' headerText='Last Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataUsersFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for users -->

<div bsModal #activeDataUsersGridFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_Users">{{activeUsersModalName}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataUsersGridFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterActivedata [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings'
                    (actionBegin)="actionBeginActive($event, gridFilterActivedata)"
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdAll($event,gridFilterActivedata)">
                    <e-columns>
                        <e-column field='FirstName' headerText='First Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                        <e-column field='LastName' headerText='Last Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataUsersGridFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>


<!-- all data table filter for stores -->
<div bsModal #allDatastoresFilter="bs-modal" [config]="modalConfig" class="modal fade fadecontainer" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1"> 
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content" [ngStyle]="{'top': ModuleName == 'AccountingInterface'? 'auto' : '-19px'}">
            <div class="modal-header">
                <h5 class="modal-title">{{AllDataHeader}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDatastoresFilter.hide();gridFilterStoreAlldata.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-padding" style="padding: 13px;">
                <ejs-grid #gridFilterStoreAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterStoreAlldata)"
                    (actionBegin)="actionBegin($event, gridallFilterAllStores)">
                    <e-columns>
                        <e-column field='Name' headerText='Store Name' width='120' textAlign='Left' type='string'>
                            <ng-template #template let-data>
                            <span class="dataName" [title]="data.Name">{{data.Name}}</span>
                          </ng-template>
                        </e-column>
                        <e-column field='State.Name' headerText='State' width='100' textAlign='Left' type='string'>
                            <ng-template #template let-data>
                                <span class="dataName" [title]="data.State?.Name">{{data.State?.Name}}</span>
                            </ng-template>
                        </e-column>
                        <e-column field='searchGenericList' [visible]="(ModuleName === 'ReportsModule' || ModuleName === 'AccountingInterface')" headerText='Generic' width='100' textAlign='Left'>
                          <ng-template #template let-data>
                            <ul class="searchGenericList">
                              <li *ngFor="let item of data.GenericStoreGroups" [title]="item">{{item}}</li>
                            </ul>
                          </ng-template>
                        </e-column>
                        <e-column field='District' headerText='District' width='100' textAlign='Left' type='string'>
                            <ng-template #template let-data>
                                <span class="dataName" [title]="data.District">{{data.District}}</span>
                            </ng-template>
                        </e-column>
                        <e-column field='RegionStoreGroup' headerText='Region' width='100' [visible]="(ModuleName === 'ReportsModule' || ModuleName === 'AccountingInterface')" textAlign='Left' type='string'>
                            <ng-template #template let-data>
                                <span class="dataName" [title]="data.RegionStoreGroup">{{data.RegionStoreGroup}}</span>
                            </ng-template>
                        </e-column>
                        <e-column field='Zip' headerText='Zip' width='100' textAlign='Left' type='string'>
                            <ng-template #template let-data>
                                <span class="dataName" [title]="data.Zip">{{data.Zip}}</span>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer" [ngStyle]="{'padding': ModuleName == 'AccountingInterface'? '11px 15px' :'19px 15px'}">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterStoreAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="allDatastoresFilter.hide();gridFilterStoreAlldata.clearFiltering()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterStoreAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for stores -->

<div bsModal #activeDataStoresFilter="bs-modal" [config]="modalConfig" class="modal fade fadecontainer" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content" style="top: -19px;">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Stores</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataStoresFilter.hide();gridFilterStoreActivedata.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-padding">
              <ejs-grid #gridFilterStoreActivedata [dataSource]='ActiveFilterData' height='350' class="table-striped "
                        [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                        [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                        (created)="createdActive($event,gridFilterStoreActivedata)"
                        (actionBegin)="actionBeginActive($event, gridFilterStoreActivedata)">
                <e-columns>
                    <e-column field='Name' headerText='Store Name' width='120' textAlign='Left' type='string'>
                    <ng-template #template let-data>
                      <span class="dataName" [title]="data.Name">{{data.Name}}</span>
                    </ng-template>
                  </e-column>
                  <e-column field='State.Name' headerText='State' width='100' textAlign='Left' type='string'>
                    <ng-template #template let-data>
                      <span class="dataName" [title]="data.State?.Name">{{data.State?.Name}}</span>
                    </ng-template>
                  </e-column>
                  <e-column field='searchGenericList' [visible]="(ModuleName === 'ReportsModule' || ModuleName === 'AccountingInterface')" [allowFiltering]='true' headerText='Generic' width='100' textAlign='Left'>
                    <ng-template #template let-data>
                      <ul class="searchGenericList">
                        <li *ngFor="let item of data.GenericStoreGroups" [title]="item">{{item}}</li>
                      </ul>
                    </ng-template>
                  </e-column>
                  <e-column field='District' headerText='District' width='100' textAlign='Left' type='string'>
                    <ng-template #template let-data>
                      <span class="dataName" [title]="data.District">{{data.District}}</span>
                    </ng-template>
                  </e-column>
                  <e-column field='RegionStoreGroup' headerText='Region' width='100' [visible]="(ModuleName === 'ReportsModule' || ModuleName === 'AccountingInterface')" textAlign='Left' type='string'>
                    <ng-template #template let-data>
                      <span class="dataName" [title]="data.RegionStoreGroup">{{data.RegionStoreGroup}}</span>
                    </ng-template>
                  </e-column>
                  <e-column field='Zip' headerText='Zip' width='100' textAlign='Left' type='string'>
                    <ng-template #template let-data>
                      <span class="dataName" [title]="data.Zip">{{data.Zip}}</span>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
            <div class="modal-footer" style="padding: 20px 15px;">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterStoreActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="activeDataStoresFilter.hide();gridFilterStoreActivedata.clearFiltering()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterStoreActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- all data table filter for Merchandise -->
<div bsModal #allDataMercFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">{{allMerchModalName}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataMercFilter.hide();gridFilterMercAlldata.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterMercAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterMercAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterMercAlldata)">
                    <e-columns>
                        <e-column field='Name' headerText='Merchandise Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterMercAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="allDataMercFilter.hide();gridFilterMercAlldata.clearFiltering()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterMercAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for Merchandise -->

<div bsModal #activeDataMercFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">{{activeMerchModalName}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="gridFilterMercActivedata.clearFiltering();activeDataMercFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterMercActivedata [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridFilterMercActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterMercActivedata)">
                    <e-columns>
                        <e-column field='Name' headerText='Merchandise Name' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterMercActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="gridFilterMercActivedata.clearFiltering();activeDataMercFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterMercActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- all data table filter for Merchandise Packs -->
<div bsModal #allDataMercPackFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Merchandise Packs</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataMercPackFilter.hide();gridFilterMercPackAlldata.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterMercPackAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterMercPackAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterMercPackAlldata)">
                    <e-columns>
                        <e-column field='Name' headerText='Merchandise Pack' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterMercPackAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="allDataMercPackFilter.hide();gridFilterMercPackAlldata.clearFiltering()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterMercPackAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for Merchandise Packs-->

<div bsModal #activeDataMercPackFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Merchandise Packs</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataMercPackFilter.hide();gridFilterMercPackActivedata.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterMercPackActivedata [dataSource]='ActiveFilterData' height='350'
                    class="table-striped " [gridLines]='lines' [filterSettings]='filterSettings'
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdActive($event,gridFilterMercPackActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterMercPackActivedata)">
                    <e-columns>
                        <e-column field='Name' headerText='Merchandise Pack' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterMercPackActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="activeDataMercPackFilter.hide();gridFilterMercPackActivedata.clearFiltering()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterMercPackActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- all data table filter for Units  -->
<div bsModal #allDataunitsFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{AllDataHeader}}({{AllFilterData?.length || 0}})</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="allDataunitsFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterUnitsAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterUnitsAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterUnitsAlldata)">
                    <e-columns>
                        <e-column field='UnitNo' headerText='Unit #' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterUnitsAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataunitsFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterUnitsAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for units-->

<div bsModal #activeDataunitsFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">{{ActiveHeader}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataunitsFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterUnitsActivedata [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridFilterUnitsActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterUnitsActivedata)">
                    <e-columns>
                        <e-column field='UnitNo' headerText='Unit #' width='120' textAlign='Left' type='string'>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterUnitsActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataunitsFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterUnitsActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>


<!-- all data table filter for Units Type -->
<div bsModal #allDataunitTypesFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{AllDataHeader}}</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataunitTypesFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterUnitsTypeAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterUnitsTypeAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterUnitsTypeAlldata)">
                    <e-columns>
                        <e-column field='UnitType' headerText='Unit Type' width='120' textAlign='Left' type='string'>
                        </e-column>

                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterUnitsTypeAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataunitTypesFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterUnitsTypeAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for unitsType-->

<div bsModal #activeDataunitTypesFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Unit Type</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataunitTypesFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterUnitsTypeActivedata [dataSource]='ActiveFilterData' height='350'
                    class="table-striped " [gridLines]='lines' [filterSettings]='filterSettings'
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdActive($event,gridFilterUnitsTypeActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterUnitsTypeActivedata)">
                    <e-columns>
                        <e-column field='UnitType' headerText='Unit Type' width='120' textAlign='Left' type='string'>
                        </e-column>

                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterUnitsTypeActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataunitTypesFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterUnitsTypeActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- ------------------------------------------------->

<div bsModal #allDataInsurancefilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Insurance</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataInsurancefilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridAlldataInsurance [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridAlldataInsurance)"
                    (actionBegin)="actionBegin($event, gridAlldataInsurance)">
                    <e-columns>
                        <e-column field='Name' headerText='All Insurance' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridAlldataInsurance,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataInsurancefilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridAlldataInsurance,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #activeInsurancefilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">Active Insurance</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeInsurancefilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridActivedataInsurance [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridActivedataInsurance)"
                    (actionBegin)="actionBeginActive($event, gridActivedataInsurance)">
                    <e-columns>
                        <e-column field='Name' headerText='Active Insurance' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridActivedataInsurance,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeInsurancefilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridActivedataInsurance,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- all data table filter for Fees & Charges -->
<div bsModal #allDataFeesAndCharges="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Fees & Charges</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataFeesAndCharges.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterFeesAndChargesAlldata [dataSource]='AllFilterData' height='350'
                    class="table-striped " [gridLines]='lines' [filterSettings]='filterSettings'
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdAll($event,gridFilterFeesAndChargesAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterFeesAndChargesAlldata)">
                    <e-columns>
                        <e-column field='Name' headerText='Fees & Charges' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterFeesAndChargesAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataFeesAndCharges.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterFeesAndChargesAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- active data table filter for Fees & Charges-->

<div bsModal #activeDataFeesAndCharges="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Fees & Charges</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataFeesAndCharges.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterFeesAndChargesActivedata [dataSource]='ActiveFilterData' height='350'
                    class="table-striped " [gridLines]='lines' [filterSettings]='filterSettings'
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdActive($event,gridFilterFeesAndChargesActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterFeesAndChargesActivedata)">
                    <e-columns>
                        <e-column field='Name' headerText='Fees & Charges' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterFeesAndChargesActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataFeesAndCharges.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterFeesAndChargesActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #allLateandLien="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Late & Lien</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="allLateandLien.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterLateAndLienAlldata [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridFilterLateAndLienAlldata)"
                    (actionBegin)="actionBegin($event, gridFilterLateAndLienAlldata)">
                    <e-columns>
                        <e-column field='Name' headerText='Late & Lien' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridFilterLateAndLienAlldata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allLateandLien.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridFilterLateAndLienAlldata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<div bsModal #activeDataLateAndLien="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Late & Lien</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataLateAndLien.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridFilterLateAndLienActivedata [dataSource]='ActiveFilterData' height='350'
                    class="table-striped " [gridLines]='lines' [filterSettings]='filterSettings'
                    (rowSelected)='rowSelectedAllData($event)' [pageSettings]='initialPage' allowFiltering='true'
                    allowSorting='true' (created)="createdActive($event,gridFilterLateAndLienActivedata)"
                    (actionBegin)="actionBeginActive($event, gridFilterLateAndLienActivedata)">
                    <e-columns>
                        <e-column field='Name' headerText='Late & Lien' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridFilterLateAndLienActivedata,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataLateAndLien.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridFilterLateAndLienActivedata,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- All Unit Groups Filter Start -->

<div bsModal #AllDataUnitGroupsfilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Unit Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataUnitGroupsfilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridAllUnitsGroupsData [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridAllUnitsGroupsData)"
                    (actionBegin)="actionBegin($event, gridAllUnitsGroupsData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridAllUnitsGroupsData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="allDataUnitGroupsfilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridAllUnitsGroupsData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- All Unit Groups Filter End -->

<!-- Active Units Groups Filter Start -->
<div bsModal #ActiveDataUnitGroupsFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Unit Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataUnitGroupsFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridActiveUnitsGroupsData [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridActiveUnitsGroupsData)"
                    (actionBegin)="actionBeginActive($event, gridActiveUnitsGroupsData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridActiveUnitsGroupsData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="activeDataUnitGroupsFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridActiveUnitsGroupsData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- Active Units Groups Filter End -->


<!-- All Taxes Filter Start -->

<div bsModal #AllDataTaxfilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All Taxes</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="AllDataTaxfilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridAllTaxData [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridAllTaxData)" (actionBegin)="actionBegin($event, gridAllTaxData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                        <e-column field='Percentage' headerText='Percentage' [allowFiltering]="false" width='120'
                            textAlign='Left'></e-column>

                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridAllTaxData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="AllDataTaxfilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridAllTaxData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- All Taxes Filter End -->



<!-- Active Taxes Filter Start -->
<div bsModal #ActiveDataTaxFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active Taxes</h5>
                <button type="button" class="close pull-right" aria-label="Close" (click)="ActiveDataTaxFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridActiveTaxData [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridActiveTaxData)"
                    (actionBegin)="actionBeginActive($event, gridActiveTaxData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                        <e-column field='Percentage' headerText='Percentage' width='120' [allowFiltering]="false"
                            textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridActiveTaxData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="ActiveDataTaxFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridActiveTaxData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- Active Taxes Filter End -->


<!-- All Store group Filter Start -->

<div bsModal #AllDataStoreGroupfilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">All Store Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="allDataStoreGroupfilter.hide();gridAllStoreGroupData.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridAllStoreGroupData [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridAllStoreGroupData)"
                    (actionBegin)="actionBegin($event, gridAllStoreGroupData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridAllStoreGroupData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="allDataStoreGroupfilter.hide();gridAllStoreGroupData.clearFiltering()">Cancel</button>
                <button class="btn btn-primary" type="button" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridAllStoreGroupData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- All Store group Filter End -->

<!-- Active Store group Filter Start -->
<div bsModal #ActiveDataStoreGroupFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Active Store Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="activeDataStoreGroupFilter.hide();gridActiveStoreGroupData.clearFiltering()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridActiveStoreGroupData [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridActiveStoreGroupData)"
                    (actionBegin)="actionBeginActive($event, gridActiveStoreGroupData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridActiveStoreGroupData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button"
                    (click)="activeDataStoreGroupFilter.hide();gridActiveStoreGroupData.clearFiltering()">Cancel</button>
                <button class="btn btn-primary" type="button" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridActiveStoreGroupData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- Active Store group Filter End -->


<!-- All User Groups Filter Start -->

<div bsModal #AllDataUserGroupfilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@All_Stores">All User Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="AllDataUserGroupfilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridAllUGData [dataSource]='AllFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdAll($event,gridAllUGData)" (actionBegin)="actionBegin($event, gridAllUGData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilter'
                    (click)="clearFilterAll(gridAllUGData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="AllDataUserGroupfilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilter'
                    (click)="loadToAllGrid(gridAllUGData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>

<!-- All User Groups Filter End -->


<!-- Active User Groups Filter Start -->
<div bsModal #ActiveDataUserGroupFilter="bs-modal" [config]="modalConfig" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" i18n="@@Active_stores">Active User Groups</h5>
                <button type="button" class="close pull-right" aria-label="Close"
                    (click)="ActiveDataUserGroupFilter.hide()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ejs-grid #gridActiveTaxData [dataSource]='ActiveFilterData' height='350' class="table-striped "
                    [gridLines]='lines' [filterSettings]='filterSettings' (rowSelected)='rowSelectedAllData($event)'
                    [pageSettings]='initialPage' allowFiltering='true' allowSorting='true'
                    (created)="createdActive($event,gridActiveTaxData)"
                    (actionBegin)="actionBeginActive($event, gridActiveTaxData)">
                    <e-columns>
                        <e-column field='Name' headerText='Name' width='120' textAlign='Left'></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary me-3" type="button" i18n="@@Clear" [disabled]='disableFilterActive'
                    (click)="clearFilterActive(gridActiveTaxData,'CLEAR')">Clear</button>
                <button class="btn btn-outline-primary me-3" type="button" (click)="ActiveDataUserGroupFilter.hide()"
                    i18n="@@Cancel">Cancel</button>
                <button class="btn btn-primary" type="button" i18n="@@Ok" [disabled]='disableFilterActive'
                    (click)="loadToActiveGrid(gridActiveTaxData,'OK')">OK</button>
            </div>
        </div>
    </div>
</div>
<!-- Active User Groups Filter End -->
